import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

export default function SidebarCollapseButton({ collapsed, onClick }) {
  return (
    <button
      type="button"
      title={collapsed ? "Expand section" : "Collapse section"}
      aria-label={collapsed ? "Expand section" : "Collapse section"}
      aria-expanded={!collapsed}
      className="btn btn-outline-primary btn-sm border-0 ms-auto"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={collapsed ? faAngleDown : faAngleUp} />
    </button>
  );
}
